var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSettingsIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.768 4.066A2.5 2.5 0 1 1 3.232 7.6a2.5 2.5 0 0 1 3.536-3.535M16.667 5.834H7.5M16.768 12.4a2.5 2.5 0 1 1-3.536 3.535 2.5 2.5 0 0 1 3.536-3.536M3.333 14.167H12.5",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSettingsIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SettingsIcon.95101f08.svg";
export { ForwardRef as ReactComponent };